export const environment = {
    production: false,
    webServiceUrl: 'https://tuki.com.pe/api/',
};